__webpack_require__.p = "https://portal-int.hr-dc5-dev.dtek.cloud/";